import type {
  AutoCompleteSuggestion,
  IngredientId,
} from '@libs/trip-planner-interfaces';

export enum SelectDestinationEmitType {
  AddDestination = 'AddDestination',
  AddDestinationToOwnStay = 'AddDestinationToOwnStay',
  UpdateDestination = 'UpdateDestination',
}

interface AddDestinationEmit {
  type: SelectDestinationEmitType.AddDestination;
  suggestion: AutoCompleteSuggestion;
}

interface AddDestinationToOwnStayEmit {
  type: SelectDestinationEmitType.AddDestinationToOwnStay;
  suggestion: AutoCompleteSuggestion;
  ingredientId: IngredientId;
}

interface ChangeDestinationEmit {
  type: SelectDestinationEmitType.UpdateDestination;
  suggestion: AutoCompleteSuggestion;
  ingredientId: IngredientId;
}

export type SelectDestinationEmit =
  | AddDestinationEmit
  | AddDestinationToOwnStayEmit
  | ChangeDestinationEmit;
